import styled from '@emotion/styled';
import { breakpoint, colors, typography } from 'component-library';

export type BadgeVariant = 'primary' | 'secondary' | 'ghost';

const badgeStyles: Record<BadgeVariant, { background: string; color: string; border: string }> = {
  primary: {
    background: colors.primary.blueTint3,
    color: colors.primary.blueShade2,
    border: `1px solid ${colors.primary.blueTint2}`,
  },
  secondary: {
    background: colors.secondary.greenTint1,
    color: colors.secondary.green,
    border: `1px solid ${colors.secondary.green}`,
  },
  ghost: {
    background: 'transparent',
    color: colors.primary.grey,
    border: `1px solid ${colors.monochrome.grey40}`,
  },
};

export const StyledBadge = styled.span<{ variant?: BadgeVariant }>`
  ${typography.body.small};
  display: inline-flex;
  align-items: center;
  align-self: center;
  width: fit-content;
  background: ${({ variant = 'primary' }) => badgeStyles[variant].background};
  color: ${({ variant = 'primary' }) => badgeStyles[variant].color};
  border: ${({ variant = 'primary' }) => badgeStyles[variant].border};

  /* Mobile: match Label slim styling */
  padding: 0 4px;
  border-radius: 2px;

  @media (min-width: ${breakpoint.medium}px) {
    padding: 2px 8px;
    border-radius: 4px;
    position: absolute;
    top: 1.25em;
    right: 6em;
  }
`;
